// 16px is the browser default font size
export const pxToRem = (...blocks) => blocks.map(block => `${block / 16}rem`).join(' ')

const DefaultColumnClassName = ({ className }) => className || 'us-col-sm-12'

export default DefaultColumnClassName
